import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    
    if (this.authService.isAuthenticated()) {
      // Check if route requires specific user type
      const requiredUserType = route.data['userType'];
      
      if (requiredUserType) {
        const currentUserType = this.authService.getUserType();

        console.log('Current User Type:', currentUserType);
        console.log('Required User Type:', requiredUserType);
        
        if (currentUserType !== requiredUserType) {
          // this.toastr.error('Access denied. You do not have permission to access this page.', 'Access Denied');
          this.redirectBasedOnUserType();
          return false;
        }
      }
      
      return true;
    }

    // User is not authenticated
    this.toastr.warning('Please login to access this page.', 'Authentication Required');
    this.router.navigate(['/login'], { 
      queryParams: { returnUrl: state.url }
    });
    return false;
  }

  private redirectBasedOnUserType(): void {
    const userType = this.authService.getUserType();
    if (userType === 'expert') {
      this.router.navigate(['/dashboard']);
    } else {
      this.router.navigate(['/user-dashboard']);
    }
  }
} 